import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { setDocTitle } from "../../../functions/HelperFuncs";

export default {
  data() {
    return {
      id: this.$options.name,
      selectedStepId: "upload",
      selectedLastStepId: "",
      selectedStepData: {},
      steps: [
        {
          id: "upload",
          nextStepIds: ["upload-files"],
          lastStepId: "",
          wipeUploadFolderInfo: true,
        },
        {
          id: "upload-preview", //preview of to upload files
          nextStepIds: ["upload-dist"],
          lastStepId: "upload",
          wipeUploadFolderInfo: true,
        },
        {
          id: "upload-dist", //preview of to upload files
          nextStepIds: ["upload-preview-dist"],
          lastStepId: "",
          wipeUploadFolderInfo: false,
        },
        {
          id: "upload-preview-dist", //preview of to upload files
          nextStepIds: ["upload-uploading"],
          lastStepId: "",
          wipeUploadFolderInfo: false,
        },
        {
          id: "upload-uploading", //preview of to upload files
          nextStepIds: [],
          lastStepId: "",
          wipeUploadFolderInfo: true,
        },
      ],
    };
  },
  beforeMount() {
    //check if mobile
    this.redirect();
  },
  created() {
    setDocTitle("upload", this);

    EventBus.$on(`${this.id}-updateStep`, this.updateStep);

    this.pickedDistAndFiles();

    this.resetUrl();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //last link
      vm.setUploadFolderInfo(from, to);
    });
  },

  methods: {
    setUploadFolderInfo(from, to) {
      if (from) {
        if (
          (from.fullPath.includes("myspace/expanded/") ||
            from.fullPath.includes("home/expanded/")) &&
          from.params.id &&
          to.fullPath.includes("/upload")
        ) {
          //previous link was a folder
          this.$store.state.uploadFolderInfo = {
            id: from.params.id,
            name: "...",
          };

          //get folder details
          this.$axios
            .get(
              `${baseUrl}/folderdetail?folder=${from.params.id}&myspace=${
                from.fullPath.includes("myspace/expanded/") ? 1 : 0
              }`,
              {
                responseType: "json",
              }
            )
            .then((r) => {
              this.$store.state.uploadFolderInfo = r.data;
            });
        }
      }
    },
    resetUrl() {
      this.$router.replace(`/${this.$store.state.company}/upload`);
    },
    redirect() {
      if (!this.$store.state.isMobile) {
        //is desktop so go to main screen
        this.$router.replace(`/${this.$store.state.company}`);
      }
    },
    updateStep(data) {
      this.selectedStepId = data.id;
      this.selectedStepData = this.steps.filter(
        (step) => step.id === data.id
      )[0];

      //add extra data if present
      if (data.data) {
        this.selectedStepData.data = data.data;
      }

      //set last step
      this.selectedLastStepId = data.lastStepId
        ? data.lastStepId
        : this.selectedStepData.lastStepId;

      if (this.selectedStepData.wipeUploadFolderInfo) {
      }

      //save the files in the store for uploading later
      if (this.selectedStepData.data) {
        if (this.selectedStepData.data.files) {
          this.$store.state.uploadFiles = [...this.selectedStepData.data.files];
        }
      }

      //if upload-dist
      if (this.selectedStepId === "upload-dist") {
        //set uploading to true to display the options in the fileHolder and the spaces
        this.$store.state.isUploadingMobile = true;

        //go to spaces
        this.$router.push(`/${this.$store.state.company}/spaces`);
      } else {
        //add link param for returning in the steps
        if (data.id !== "upload") {
          this.$router.push(
            `/${this.$store.state.company}/upload/${data.id.replace(
              "upload-",
              ""
            )}`
          );
        } else {
          this.$router.push(`/${this.$store.state.company}/upload`);
        }
      }
    },
    pickedDistAndFiles() {
      if (
        this.$store.state.uploadFiles.length &&
        this.$store.state.uploadFolderInfo.name
      ) {
        //has picked update the steps
        EventBus.$emit(`${this.id}-updateStep`, {
          id: "upload-preview-dist",
        });
      }
    },
    uploadDone() {
      this.resetUploadItems();
      //redirect to the folder

      const info = this.$store.state.uploadFolderInfo;

      this.$router.push(
        `/${this.$store.state.company}/${
          info.myspace ? "myspace" : "home"
        }/expanded/${info.id}`
      );
    },

    resetUploadItems() {
      this.$store.state.uploadFiles = [];
      this.$store.state.isUploadingMobile = false;
    },
  },
  watch: {
    $route() {
      if (
        !this.$store.state.uploadFolderInfo.id &&
        !this.$store.state.uploadFiles.length
      ) {
        //if nothing set here preform reset
        /*EventBus.$emit(`${this.id}-updateStep`, {
          id: "upload",
        });*/
      }
    },
    "$store.state.uploadFolderInfo"() {},
  },
};
